import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import SaleFooter from '../Partials/SaleFooter/SaleFooter';
import UserAddressForUpgrade from '../Partials/UserAddressForUpgrade/userAddressForUpgrade';
import { goToPage, setSelectedUserAddressForUpgrade, reportDWH, setIsSubmit, setOrderType, setLeadPage } from '../saleJetBlockSlice';
import { goToNextPage } from '../saleBlockAsyncThunk';

const UserAddressForUpgradePage = (props) => {

  //page params
  let isDisplayFooter = true;
  let btnText = 'המשך';
  let currentPageFunction = handlePageContinue;
  let totalPrice = null;
  let priceText = '';
  let formid = 'saleJet';
  //page params

  let currentPageHeadline = (
    <div className='page-headline-wrapper'>
      <h1 className='sale-title'></h1>
      <h1 className='sale-title-big'>
        היי {props._authentication.loginData.userDetails.firstName}, איזה כיף לנו, אנחנו רואים  <br />
        שיש לך כבר שירותים ב{window.Config.brand_Name_HE}
      </h1>
      <h2 className='sale-title-small'>
        האם תרצה לשדרג את החבילה הקיימת שלך או <br />
        להוסיף שירות נוסף?
      </h2>
    </div>
  );

  let currentPageView = (
    <div>
      <UserAddressForUpgrade
        userAddresses={props.userAddresses}
        onSelectedUserAddress={handleSelectedUserAddress}
        selectedUserAddress={props.selectedUserAddress}
        selectedAddress={props.selectedAddress}
        isSelectedSeparateInvoice={props.isSelectedSeparateInvoice}
        onSubmit={props.isSubmit}
        onValid={handlePageValidate}
        saleType={props.saleType}
      />
    </div>
  );

  return (
    <div className='slideAnimation'>
      {currentPageHeadline}
      <div className='sale-page-content'>
        <form noValidate id='sale' onSubmit={handleSubmit}>
          {currentPageView}
        </form>
        <SaleFooter isDisplayFooter={isDisplayFooter} btnText={btnText} onclick={currentPageFunction} price={totalPrice} priceText={priceText} formid={formid} />
      </div>
    </div>
  );


  function handleSelectedUserAddress(data) {
    props.setSelectedUserAddressForUpgrade(data);
  }


  function handlePageValidate(isValid) {
    props.setIsSubmit(false);
    if (isValid) {
      handlePageContinueAfterValid();
    }
  }


  function handlePageContinue() {
    props.setIsSubmit(true);
  }


  function handlePageContinueAfterValid() {

    if (props.isSelectedSeparateInvoice) {
      props.setOrderType('provide');
      props.goToNextPage();
    }
    else {

      //------------------- Leads -------------------
      if (props.selectedAddress && Object.keys(props.selectedAddress).length > 0) {
        if (props.selectedUserAddress.productAddress?.cityName != props.selectedAddress?.cityName
          || props.selectedUserAddress.productAddress?.streetName != props.selectedAddress?.streetName
          || props.selectedUserAddress.productAddress?.houseNumber != props.selectedAddress?.home
          || props.selectedUserAddress.productAddress?.apartment != props.selectedAddress?.apartment) {
          if (props.saleType == 'triple') {
            props.setLeadPage('differentAddress');
            return;
          }
        }
      }
      if (props.selectedUserAddress.infrastructure == '') {
        props.setLeadPage('noFiber');
        return;
      }
      if (props.selectedUserAddress.infrastructure == 'BZ') {
        props.setLeadPage('hasCopper');
        return;
      }
      if (props.selectedUserAddress.hasMapa) {
        props.setLeadPage('hasMapa');
        return;
      }
      const hasTv = props.selectedUserAddress.products.find(x => x.type.toLowerCase() == 'tv');
      const hasInternet = props.selectedUserAddress.products.find(x => x.type.toLowerCase() == 'internet');

      if (hasTv && hasInternet) {
        props.setLeadPage('hasTvAndInternet');
        return;
      }
      //------------------- Leads -------------------     

      props.setOrderType('replace');
      if (props.saleType == 'triple') {
        props.goToNextPage();
      }
      else {
        props.goToPage('packagesPage');
      }
    }
  }


  function handleSubmit(event) {
    event.preventDefault();
  }
};

const mapStateToProps = (state) => {
  return {
    saleType: state.saleJetBlock.saleType,
    offerName: state.saleJetBlock.offerName,
    selectedPackage: state.saleJetBlock.selectedPackage,
    saleCatalog: state.saleJetBlock.saleCatalog,
    saleBlockData: state.saleJetBlock.saleBlockData,
    userAddresses: state.saleJetBlock.userAddressForUpgradePage.userAddresses,
    selectedUserAddress: state.saleJetBlock.userAddressForUpgradePage.selectedAddress,
    selectedAddress: state.saleJetBlock.addressPage.selectedAddress,
    isSelectedSeparateInvoice: state.saleJetBlock.userAddressForUpgradePage.isSelectedSeparateInvoice,
    isSubmit: state.saleJetBlock.isSubmit,

    //other states
    _authentication: state.authentication,
  };
};

const mapDispatchToProps = {
  goToPage,
  setSelectedUserAddressForUpgrade,
  reportDWH,
  setIsSubmit,
  setOrderType,
  goToNextPage,
  setLeadPage
};

export default connect(mapStateToProps, mapDispatchToProps)(UserAddressForUpgradePage);
